import React, { useContext } from 'react';
import { RFC } from 'shared/types/sharedTypes';
import { UserContext } from '../../context/UserContext';
import { useAsync } from 'shared/hooks/useAsync';
import LoadingSpinner from 'shared/components/Loader';
import { userApiManager } from '../../network/apiManager';
import { LoginForm } from './components/LoginForm';
import { SignInRequest } from 'shared/types/Auth';
import { ErrorMessage } from 'shared/components/Text';

export const Login: RFC = () => {
    const { userLoading, setCurrentLogin } = useContext(UserContext);

    const onSubmit = async (loginInfo: SignInRequest) => {
        //clear any errors before submitting
        loginWithPassword.clearError();
        try {
            //submit login to server and set user in context
            await userApiManager.Auth.loginWithPassword(loginInfo, setCurrentLogin);

        } catch (err) {
            console.log(err);
            throw err;
        }
    };

    const loginWithPassword = useAsync<void>(
        loginInfo => onSubmit(loginInfo),
        'Error logging in. Check your username and password.'
    );

    return (
        <>
            {!userLoading && !loginWithPassword.pending ? (
                <>
                    <LoginForm onSubmit={loginWithPassword.execute} />
                    {loginWithPassword.error && <ErrorMessage text={loginWithPassword.error} />}
                </>
            ) : (
                <LoadingSpinner />
            )}
        </>
    );
};
